import loadable from "@loadable/component";
import Layout from "@/_LayoutsRelated/layout/Layout";
import UnbxdPosts from "../../components/SearchComponent/UnbxdComponents/UnbxdPosts/UnbxdPosts";
import stl from "./Filters.module.css";
import SpecsSection from "../../components/SearchComponent/UnbxdComponents/SpecsSection/SpecsSection";
import useFilterPage, {useSearchResultsData} from "@/pages/search/searchHooks/useSearchAndFilters";


const fallback = {
    fallback: null,
};

const UnbxdAsideFilters = loadable(
    () =>
        import("../../components/SearchComponent/UnbxdComponents/UnbxdAsideFilters/UnbxdAsideFilters"), fallback
);

const Unbxd = () => {


    const {
        isLoading, searchResults,
        sort, searchTerm,
        //filters
        setShowFilters, showFilters,
        // Location Flags
        isAutosPage,
        isYearsPage,
        //constants
    } = useFilterPage();

    const {
        filters,
        selectedOptions,
        dealFacet,
        specs,
        // data
        metaData,
    } = useSearchResultsData();


    return (
        <Layout
            hideBannerCssOnly
            hasNavBar
            pageName="search"
            searchSearchHeader
            headHideLinks
            disableLoader
            hideHeaderOnmobile
            showSearchBar
            // ={!isLoading}
        >
            <section
                className={[
                    stl.searchPageContainer,
                    "container",
                    "extraWideContainer",
                    isLoading ? isLoading : "",//todo is it a bug? isLoading is a boolean
                    stl.NewContainer,
                ].join(" ")}
            >
                <UnbxdAsideFilters
                    filters={filters}
                    selectedOptions={selectedOptions}
                    sort={sort}
                    loading={isLoading}
                    showFilters={showFilters}
                    setShowFilters={setShowFilters}
                    dealFacet={dealFacet}
                    postsCount={metaData?.productsCount}
                    searchTerm={searchTerm}
                    metaData={metaData}
                />

                <UnbxdPosts />
            </section>
            <SpecsSection
                selectedOptions={selectedOptions}
                isAutos={isAutosPage || isYearsPage}
                specs={specs}
            />
        </Layout>
    );
};

export default Unbxd;
